export enum CreateManifestSteps {
  Details = "details",
  Result = "result",
}
